export default {
  sections: {
    resources: 'Recursos',
    programs: 'Programas educativos',
    folders: 'Carpetas',
    topics: 'Temáticas relacionadas',
    subtopics: 'Sub-Temáticas relacionadas',
    nextEphemeride: 'Próximas efemérides',
    pastEphemeride: 'Efemérides pasadas',
    currentEphemeride: 'Efemérides del mes'
  },
  seeMore: 'Ver más'
}

export const en = {
  sections: {
    resources: 'Resources',
    programs: 'Programs',
    folders: 'Folders',
    topics: 'Topics',
    subtopics: 'Subtopics',
    nextEphemeride: 'Next events',
    pastEphemeride: 'Past events',
    currentEphemeride: 'Events of this month'
  },
  seeMore: 'See more'
}

export const ca = {
  sections: {
    resources: 'Recursos',
    programs: 'Programes educatius',
    folders: 'Carpetes',
    topics: 'Temàtiques relacionades',
    subtopics: 'Sub-temàtiques relacionades',
    nextEphemeride: 'Pròximes efemèrides',
    pastEphemeride: 'Efemèrides passades',
    currentEphemeride: 'Efemèrides del mes'
  },
  seeMore: 'Veure més'
}
